import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import * as firebase from 'firebase/app';
import "firebase/auth";
import "firebase/database";
import {BootstrapVue} from 'bootstrap-vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import vSelect from "vue-select";
import User from "@/lib/models/User";
import { Datetime } from 'vue-datetime'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import "vue-select/dist/vue-select.css";
import "./assets/style/style.scss"
import "./lib/fontAwesomeIncluder"
import VueSweetalert2 from 'vue-sweetalert2';
import 'vue-datetime/dist/vue-datetime.css'
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.component('datetime', Datetime);
Vue.component("v-select", vSelect);
Vue.component('fa-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.config.productionTip = false;

let app: any = null;
let config = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID
};
firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(() => {
    if (!app) {
        let prePromise = new Promise((resolve) => {
            resolve(null);
        });
        const currentUser = firebase.auth().currentUser;

        if (currentUser) {
            prePromise = new Promise((resolve) => {
                firebase.database().ref('/users/' + currentUser.uid).once('value').then(function (snapshot) {
                    resolve(snapshot.val());
                });
            });
        }

        prePromise.then((user) => {

            user = currentUser ? (new User()).fromObject(Object.assign({}, {
                uid: currentUser.uid,
                email: currentUser.email,
            }, user)) : null;
            store.commit('updateUser', user);

            Vue.prototype.$firebase = firebase;
            Vue.prototype.$firebaseUser = currentUser;

            app = new Vue({
                router,
                store,
                render: h => h(App)
            }).$mount('#app');
        })

    }
});



